import React from 'react';
function useOnInitCb({ cb, condition }) {
    const [cbFired, setCbFired] = React.useState(false);
    React.useEffect(() => {
        if (condition && !cbFired) {
            setCbFired(true);
            cb();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [condition, cbFired]);
    return cbFired;
}
export default useOnInitCb;
